<template>
 <header class="d-flex justify-content-between align-items-center">
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu"
      ><ul>
        <li></li>
        <li></li>
        <li></li></ul
    ></label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav
      class="nav_center"
      style="padding: 0"
      :style="{ display: isMenuVisible ? 'block' : 'none' }"
    >
      <ul style="list-style: none">
       <li
          :class="{ topmenuactive: activeTab === 'Gioithieu' }" style="display: none;"
          @click="changeTab('Gioithieu')"
        >
          <a id="urlGioithieu" href="vi/dichvucong-nongnghiepthongminh#gioithieu" style="color: white;">Giới thiệu</a>
        </li>
       
     <li
          :class="{ topmenuactive: activeTab === 'Thanhtoanthongminh' }" style="display: none;"
          @click="changeTab('Thanhtoanthongminh')"
        >
          <a id="urlThanhtoanthongminh" href="vi/dichvucong-nongnghiepthongminh#thanhtoanthongminh" style="color: white;">Thanh toán thông minh</a>
        </li>
          <li
          :class="{ topmenuactive: activeTab === 'Giaoducthongminh' }" style="display: none;"
          @click="changeTab('Giaoducthongminh')" 
        >
          <a id="urlGiaoducthongminh" href="vi/dichvucong-nongnghiepthongminh#giaoducthongminh" style="color: white;">Giáo dục thông minh</a>
        </li>
         <li
          :class="{ topmenuactive: activeTab === 'Giaothongthongminh' }" style="display: none;"
          @click="changeTab('Giaothongthongminh')"
        >
          <a id="urlGiaothongthongminh" href="vi/dichvucong-nongnghiepthongminh#giaothongthongminh" style="color: white;">Giao thông thông minh</a>
        </li>
          <li
          :class="{ topmenuactive: activeTab === 'Ytethongminh' }" style="display: none;"
          @click="changeTab('Ytethongminh')"
        >
          <a id="urlYtethongminh" href="vi/dichvucong-nongnghiepthongminh#ytethongminh" style="color: white;" >Y tế thông minh</a>
        </li>
    <li
          :class="{ topmenuactive: activeTab === 'Dvcthongminh' }"
          @click="changeTab('Dvcthongminh')"
        >
          <a id="urlDvcthongminh" href="vi/dichvucong-nongnghiepthongminh#dvcthongminh" style="color: white;">{{ currentLanguage.header_text_xadichVuCongThongMinh }}</a>
        </li>
       
        <li 
          :class="{ topmenuactive: activeTab === 'Nongnghiepthongminh' }"
          @click="changeTab('Nongnghiepthongminh')"
        >
          <a id="urlNongnghiepthongminh" href="vi/dichvucong-nongnghiepthongminh#nongnghiepthongminh"  style="color: white;">{{ currentLanguage.header_text_xaNongNghiepThongMinh }}</a>
        </li>
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <div class="menu_co_right" style="display: flex">
        <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"
          ><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>
        <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/ja.jpg" />
        </a>

        <span
          class="clickShow"
          style="color: #303038; cursor: pointer; margin: auto"
          ><i class="fa fa-ellipsis-h" aria-hidden="true"></i
        ></span>
      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"
        ><img
          style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg"
        />
      </a>
    </div>
    </header>
    <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <div class="wrapper row3">
        <main class="hoc container-fluid clear bv">
          <!-- Dvcthongminh -->
          <div v-show="showThanhtoanthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlThanhtoanthongminh"></div>
        <div v-html="contentHtmlThanhtoanthongminh"></div>
      </div>
      <div v-show="showYtethongminh" class="padding-top15" style="min-height: 600px;">
        <div class="title-bai-viet " v-html="titleHtmlYtethongminh"></div>
        <div v-html="contentHtmlYtethongminh"></div>
      </div>
      <div v-show="showGiaothongthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGiaothongthongminh"></div>
        <div v-html="contentHtmlGiaothongthongminh"></div>
      </div>
      <div v-show="showGioithieu" class="padding-top15">
        <!-- <div class="title-bai-viet " v-html="titleHtmlGioithieu"></div> -->
        <div v-html="contentHtmlGioithieu"></div>
      </div>
      <div v-show="showGrok" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGrok"></div>
        <div v-html="contentHtmlGrok"></div>
      </div>
      <div v-show="showGiaoducthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGiaoducthongminh"></div>
        <div v-html="contentHtmlGiaoducthongminh"></div>
      </div>
      <div v-show="showNongnghiepthongminh" class="padding-top15" style="min-height: 600px;">
        <div class="title-bai-viet " v-html="titleHtmlNongnghiepthongminh"></div>
        <div v-html="contentHtmlNongnghiepthongminh"></div>
      </div>
      <div v-show="showDvcthongminh" class="padding-top15" style="min-height: 700px;">
        <div class="title-bai-viet " v-html="titleHtmlDvcthongminh"></div>
        <div v-html="contentHtmlDvcthongminh"></div>
      </div>
        </main>
      </div>
    </main>
  </div>
<FooterView></FooterView>
</template>
<script scope="this api replaced by slot-scope in 2.5.0+">
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import axios from "axios";


export default {
  components: {
FooterView
  },
  data() {
    return {
      activeTab: 'Dvcthongminh',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showThanhtoanthongminh: false,
      showYtethongminh: false,
      showGiaothongthongminh: false,
      showGioithieu: false,
      showGrok: false,
      showGiaoducthongminh: false,
      showNongnghiepthongminh: false,
      showDvcthongminh: false,
      showUngDungAI: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlDvcthongminh:"",
      titleHtmlThanhtoanthongminh:"",
      titleHtmlYtethongminh:"",
      titleHtmlGiaothongthongminh:"",
      titleHtmlGioithieu:"",
      titleHtmlGrok:"",
      titleHtmlGiaoducthongminh:"",
      titleHtmlNongnghiepthongminh:"",

      contentHtmlDvcthongminh:"",
      contentHtmlThanhtoanthongminh:"",
      contentHtmlYtethongminh:"",
      contentHtmlGioithieu:"",
      contentHtmlGiaothongthongminh:"",
      contentHtmlGrok:"",
      contentHtmlGiaoducthongminh:"",
      contentHtmlNongnghiepthongminh:"",
    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
    this.isMenuVisible = false;
  } else {
    this.isMenuVisible = true;
  }
  if (!this.hasMounted) {
    this.hasMounted = true;
    this.lang = localStorage.getItem("languages") || "vi";  
          this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
      this.lang = localStorage.getItem("languages") || "vi";
      if (this.lang == "vi") {
        document.title = "Vimass.vn - Y tế - dịch vụ công - nông nghiệp thông minh";
      } else if (this.lang == "en") {
        document.title = "Vimass.vn - Smart healthcare - public service - agriculture";
      } else if (this.lang == "cn") {
        document.title = "Vimass.vn - 通过音频二维码收款";
      }else if (this.lang == "kr") {
        document.title = "Vimass.vn - 오디오 QR로 돈 받기";
      }
    this.performPostRequest("1752549940885h0Sxh", "Dvcthongminh", this.lang);
    document.getElementById("urlDvcthongminh").setAttribute("href", this.lang+ "/dichvucong-nongnghiepthongminh#dvcthongminh");
    document.getElementById("urlGiaothongthongminh").setAttribute("href", this.lang+ "/dichvucong-nongnghiepthongminh#giaothongthongminh");
    document.getElementById("urlYtethongminh").setAttribute("href", this.lang+ "/dichvucong-nongnghiepthongminh#ytethongminh");
    document.getElementById("urlThanhtoanthongminh").setAttribute("href", this.lang+ "/dichvucong-nongnghiepthongminh#thanhtoanthongminh");
    document.getElementById("urlGiaoducthongminh").setAttribute("href", this.lang + "/dichvucong-nongnghiepthongminh#giaoducthongminh");
    document.getElementById("urlNongnghiepthongminh").setAttribute("href", this.lang + "/dichvucong-nongnghiepthongminh#nongnghiepthongminh");
    // document.getElementById("urlGrok").setAttribute("href", this.lang + "/dichvucong-nongnghiepthongminh#grok/");
    document.getElementById("urlGioithieu").setAttribute("href", this.lang + "/dichvucong-nongnghiepthongminh#gioithieu");
 
 
 
    const fragmentTab = window.location.hash.substring(1);
    console.log("fragmentTab "+ fragmentTab);
    
    if (fragmentTab === "chuongtrinhtaitro/dvcthongminh") {
      this.changeTab("Dvcthongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/giaothongthongminh") {
      this.changeTab("Giaothongthongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/ytethongminh") {
      this.changeTab("Ytethongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/thanhtoanthongminh") {
      this.changeTab("Thanhtoanthongminh");
    }else if (fragmentTab ==="chuongtrinhtaitro/gioithieu") {
        this.changeTab("Gioithieu");
      }else if (fragmentTab ==="chuongtrinhtaitro/grok") {
        this.changeTab("Grok");
      }else if (fragmentTab ==="chuongtrinhtaitro/giaoducthongminh") {
        this.changeTab("Giaoducthongminh");
      }else if (fragmentTab ==="chuongtrinhtaitro/nongnghiepthongminh") {
        this.changeTab("Nongnghiepthongminh");
      }  else {
      // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
      this.changeTab("Dvcthongminh");
    }
}
  },
  created() {
  const savedLanguage = localStorage.getItem("languages") || "vi";
  if (savedLanguage && languages[savedLanguage]) {
    this.currentLanguage = languages[savedLanguage];
  }
},
  methods: {
    changeLanguage(lang) {
       this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            const langReload = localStorage.getItem("languages");
            window.location.href = "/" + langReload + "/dichvucong-nongnghiepthongminh" + window.location.hash;
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        }else if (this.lang === "cn") {
        this.base64 = response.data.result.content_cn;
        this.base64Title = response.data.result.title_cn;
      }else if (this.lang === "kr") {
        this.base64 = response.data.result.content_kr;
        this.base64Title = response.data.result.title_kr;
      }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
     if (section === "Thanhtoanthongminh") {
          this.titleHtmlThanhtoanthongminh = decodeURIComponent(escape(title));
          this.contentHtmlThanhtoanthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Ytethongminh") {
          this.titleHtmlYtethongminh = decodeURIComponent(escape(title));
          this.contentHtmlYtethongminh= decodeURIComponent(escape(decodedString));
        } else if (section === "Giaothongthongminh") {
          this.titleHtmlGiaothongthongminh = decodeURIComponent(escape(title));
          this.contentHtmlGiaothongthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Gioithieu") {
          this.titleHtmlGioithieu = decodeURIComponent(escape(title));
          this.contentHtmlGioithieu = decodeURIComponent(escape(decodedString));
        }else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok= decodeURIComponent(escape(decodedString));
        } else if (section === "Giaoducthongminh") {
          this.titleHtmlGiaoducthongminh = decodeURIComponent(escape(title));
          this.contentHtmlGiaoducthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Nongnghiepthongminh") {
          this.titleHtmlNongnghiepthongminh = decodeURIComponent(escape(title));
          this.contentHtmlNongnghiepthongminh = decodeURIComponent(escape(decodedString));
        }else if (section === "Dvcthongminh") {
          this.titleHtmlDvcthongminh = decodeURIComponent(escape(title));
          this.contentHtmlDvcthongminh = decodeURIComponent(escape(decodedString));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
    //   if (window.innerWidth <= 768) {
    //     this.isMenuVisible = false;
    //   }
      this.lang = localStorage.getItem("languages") || "vi";

      const tabStates = {
       
        Thanhtoanthongminh: false,Ytethongminh: false,Giaothongthongminh: false,Gioithieu: false,ungDungAI:false,
        Dvcthongminh:false, giaoducthongminh:false, Grok: false, Nongnghiepthongminh: false
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showThanhtoanthongminh = tabStates.Thanhtoanthongminh;
      this.showYtethongminh = tabStates.Ytethongminh;
      this.showGiaothongthongminh = tabStates.Giaothongthongminh;
      this.showGioithieu = tabStates.Gioithieu;
      this.showGrok = tabStates.Grok;
      this.showGiaoducthongminh = tabStates.Giaoducthongminh;
      this.showNongnghiepthongminh = tabStates.Nongnghiepthongminh;
      this.showDvcthongminh = tabStates.Dvcthongminh;
    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {
       
        Thanhtoanthongminh: "1749203550578RBETn",
        Ytethongminh: "1752550189626581gF",
        Giaothongthongminh: "1752549754421nvevM",
        Gioithieu: "1755078954972F3zJG",
        Grok: "1755078954972F3zJG",
        Giaoducthongminh: "1754639247965v9vpG",
        Nongnghiepthongminh: "1756107534123QZOKu",
        Dvcthongminh: "1752549940885h0Sxh",
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
  .title-bai-viet{display: block;}
  .hiddentitle{display: none;}
</style>
